// Photos from a phone camera are 3-12 MB; the model reads at most ~1.5k px on
// the long edge anyway. Shrink and re-encode before upload.

const MAX_EDGE = 1568;

export async function prepareImage(file: File): Promise<{ mime: string; data: string; url: string }> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d')!.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  const url = canvas.toDataURL('image/jpeg', 0.85);
  return { mime: 'image/jpeg', data: url.slice(url.indexOf(',') + 1), url };
}
